<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div class="trans-bank" v-show="loaded">
      <div class="row bg-white trans-summary" @click="toTransAccounts">
        <div>
          <div class="summary">
            应付金额
            <label class="money">￥{{ orderInfo.to_pay_amount }}</label>
          </div>
        </div>
      </div>
      <div class="row bg-white trans-summary mt-1" @click="toTransAccounts">
        <div>
          <div class="summary">
            &nbsp;&nbsp;&nbsp;已转账
            <label class="money">￥{{ orderInfo.paid_price }}</label>
          </div>
          <div class="arrow-detail arrow">
            <span class="ic-arrow-yellow"></span>
          </div>
        </div>
      </div>
      <div class="row" v-show="showAction">
        <div class="form-header">
          <p>请确认如下查账记录是否正确</p>
        </div>
      </div>
      <div class="row" v-show="showAction">
        <div>
          <order-pay-item
            v-for="(item, index) in transList"
            :key="item.payment_id"
            :payment="item"
            :last="index == transList.length-1"
            role="customer"
          ></order-pay-item>
        </div>
      </div>
      <div class="row mt-50" v-show="showButton">
        <div class="actions">
          <mt-button type="primary" @click="onSubmitClick">{{ btn_title }}</mt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Button, MessageBox } from "mint-ui";
import OrderPayItem from "@/components/OrderPayItem";

export default {
  name: "TransList",
  data: () => ({
    // 'transList': [],
    showAction: false,
    showButton: true,
    loaded: false,
    canSubmit: false,
    btn_title: "提交"
  }),
  computed: {
    ...mapGetters({
      role: "getRole",
      orderInfo: "getOrder",
      transList: "getTransList",
      payway: "getSelectedPayway"
    })
  },
  components: {
    OrderPayItem,
    "mt-button": Button
  },
  mounted: function() {
    this.setPageTitle("查账信息登记");
    this.loadOrderDetail();
  },
  methods: {
    onSubmitClick() {
      if (this.orderInfo.has_paid === false) {
        // this.toast('订单还没付完款，请继续转账')
        this.toTransAccounts();
        return;
      }
      MessageBox.confirm(
        "请确认您录入的转账信息是否完全正确，提交后不允许修改"
      ).then(
        action => {
          console.log(action);
          if (action === "confirm") {
            this.transConfirm();
          }
        },
        action => {}
      );
    },
    toTransAccounts() {
      if (this.showButton) {
        this.$router.push("/trans/accounts");
      }
    },
    loadOrderDetail() {
      if (this.orderInfo && this.orderInfo.paid_price) {
        this.loadPayments();
        return;
      }
      this.getOrderSimpleDetail(this.$route.params.id, rs => {
        this.loadPayments();
      });
    },
    setEleAction() {
      this.showAction = this.transList.length > 0;
      this.showButton =
        this.orderInfo.pay_status !== 60 && this.orderInfo.pay_status !== 30;
      if (this.orderInfo.has_paid === true) {
        this.btn_title = "提交";
      } else {
        this.btn_title = "转账金额不足，请继续录入";
      }
      if (
        this.orderInfo.pay_status === 60 &&
        this.orderInfo.survey_code.length === 0
      ) {
        this.showSurveyNotes();
      }
      this.loaded = true;
    },
    showSurveyNotes() {
      MessageBox.alert(
        "您的客户还未做《投资者风险承受能力问卷》, 请现在引导您的客户使用订单分享链接去完成问卷"
      ).then(action => {});
    },
    loadPayments() {
      if (this.transList.length > 0) {
        this.setEleAction();
        return;
      }
      let url = "/api/orders/payments/" + this.orderInfo.order_id;
      this.$http.get(url).then(
        response => {
          // console.log(response)
          var rs = response.body;
          if (rs.code === 0) {
            this.$store.dispatch("setTransList", { items: rs.data });
            // this.transList = rs.data
            if (rs.data.length === 0) {
              if (this.payway && this.payway.routeCode) {
                this.$router.push("/trans/accounts");
              }
            }
            this.setEleAction();
          } else {
            this.handleHttpError(response);
          }
        },
        response => {
          console.log(response);
          this.handleHttpError(response);
        }
      );
    },
    transConfirm() {
      let url = "/api/orders/payments/trans/confirm/" + this.orderInfo.order_no;
      this.loading("正在提交...");
      this.$http.post(url).then(
        response => {
          console.log(response);
          this.loadingHide();
          var rs = response.body;
          if (rs.code === 0) {
            if (rs.data.has_paid === true) {
              this.showButton = false;
              if (this.role === "customer") {
                if (rs.data.action === "TransList") {
                  this.$router.go();
                  return;
                }
                this.$router.replace({
                  name: rs.data.action,
                  params: { id: this.orderInfo.order_no }
                });
                // this.$router.replace('/orders/pay/success/' + this.orderInfo.order_no)
                // this.$router.replace('/orders/verify/' + this.orderInfo.order_no)
              } else {
                this.$router.replace("/orders/" + this.orderInfo.order_no);
                // MessageBox.alert('提交成功，请留意财务核实通知；核实通过后，请引导您的客户使用订单分享链接签订合同').then(action => {})

                if (rs.data.sms_verify === 0) {
                  MessageBox.alert(
                    "保存成功，请引导您的客户去完成手机号验证"
                  ).then(action => {});
                } else {
                  MessageBox.alert("保存成功").then(action => {});
                }
              }
            } else {
              this.toast(rs.message);
            }
          } else if (rs.code === 10702) {
            this.$router.replace("/orders/" + this.orderInfo.order_no);
            this.showSurveyNotes();
          } else {
            this.handleHttpError(response, true);
          }
        },
        response => {
          console.log(response);
          this.handleHttpError(response);
        }
      );
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/payment/TransList.vue